import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Tag } from "MODULES/shared/components";
import { destroyAircraft } from "MODULES/companies/actions";

function AircraftTag(props) {
  const { aircraft } = props;

  return <Tag {...props} label={aircraft.model_number} />;
}

AircraftTag.propTypes = {
  application: PropTypes.instanceOf(Object).isRequired,
  navToPart: PropTypes.func.isRequired
};

export default connect(undefined, (dispatch, ownProps) => ({
  destroy: () => dispatch(destroyAircraft(ownProps.aircraft.id))
}))(AircraftTag);



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/Fleets/Aircraft.jsx